module ViewLogic

open Shared

open System

let sortlijsten (lijsten: Lijst list) =
    lijsten
    |> List.sortByDescending (fun lijst' -> lijst'.Created)

let sortsongs (songs: ShortSong list) =
    let strip (str: string) =
        str
        |> fun s -> s.ToLower().Trim()
        |> fun s -> s.Substring(0, 4)
        |> fun s -> s.Replace("the ", "")
        |> fun s -> s.Replace("a ", "")
        |> fun s -> s.Replace("an ", "")
        |> fun s -> s.Replace("de ", "")
        |> fun s -> s.Replace("een ", "")
        |> fun s -> s.Replace("het ", "")
        |> fun s -> s.Trim()
        |> fun s -> String.Concat(s, str.Substring(4).ToLower())

    songs
    |> List.sortBy (fun song -> (strip (song.Artist + " " + song.Name)))

let getLijst (lijsten: Lijst list) lijstid =
    lijsten
    |> List.tryFind (fun lijst -> lijst.Id = lijstid)

let getSong (songs: Song list) songid =
    songs |> List.find (fun song -> song.Id = songid)

let camelCase (str: string) =
    let firstToCap (str: string) =
        str
        |> fun s -> s.Trim()
        |> String.mapi (fun i char -> if i = 0 then Char.ToUpper char else char)

    str.Split ' '
    |> Array.filter (fun s -> s <> "")
    |> Array.map firstToCap
    |> fun strarr -> ("", strarr)
    ||> Array.fold (fun acc strpart -> acc + " " + strpart)
    |> fun s -> s.Trim()

let camelCaseSong (song: Song) =
    { song with
          Name = camelCase song.Name
          Artist = camelCase song.Artist }

